import { useAsync } from "./useAsync";

export const useFetch = <T = any>(
  asyncFn: (...args: any) => Promise<any>,
  ...args: any[]
): [T | undefined, boolean, any] => {
  const [result, isLoading, error] = useAsync(asyncFn, ...args);
  const response = result ? result.data : undefined;

  return [response, isLoading, error];
};
